import React, { Component } from "react";
import logo from "../logo.svg";

class Header extends Component {
  render() {
    return (
      <header className="app-header">
        <img src={logo} className="app-logo" alt="logo" />
        <div className="nav">
          {/* <label className="nav-item">designs</label> */}
          {/* <label className="nav-item">videos</label> */}
          {/* <label className="nav-item">riley</label> */}
          {/* <label className="nav-item">designs</label> */}
          {/* <label className="nav-item">shop</label> */}
          {/* <label className="nav-item">donate</label> */}
        </div>
      </header>
    );
  }
}

export default Header;
